module.exports = __webpack_public_path__ + "static/media/edit.bc86f175.svg";